import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../dynamicFormBuilder/FormField';
import { GridLayout } from "../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { FillFilters, FormatPhoneNumber } from '../../../common/Utils'
import { description } from 'devexpress-dashboard/model/index.metadata';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import { SearchLayout } from './Layout';
import { IM, WM } from '../../../const/constants';
import form from '../../../wm/components/transactions/dataentry/form';
import '../../../common/css/searchPage.css';
const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];


const LocationDataEntryList = (props) => {
    const dataGrid = useRef(null);
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const lowercaseModule = props.Module.toLowerCase();
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "917F86B2-3164-4315-952F-94C3E80EF8E2";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const initialFormFields = {
        IdentityId: null,
        LocationCode: null,
        Description: null,
        MinPositionIndex: null,
        MaxPositionIndex: null,
        CapacityAreaLimitFlag: null,
        CapacityArea: null,
        CapacityUnits: null,
        CapacityVolume: null,
        ClassCode: null,
        SubClassCode: null,
        UserDefinedCode1: null,
        UserDefinedCode2: null,
        UserDefinedCode3: null,
        UserDefinedCode4: null,
        UserDefinedCode5: null,
        UserDefinedCode6: null,
        UserDefinedCode7: null,
        UserDefinedCode8: null,
        UserDefinedCode9: null,
        UserDefinedCode10: null,
        CreationUserId: null,
        CreationDateTime: null,
        UserDefinedDate1: null,
        UserDefinedDate2: null,
        UserDefinedDate3: null,
        UserDefinedDate4: null,
        UserDefinedDate5: null,
        UserDefinedDate6: null,
        UserDefinedDate7: null,
        UserDefinedDate8: null,
        UserDefinedDate9: null,
        UserDefinedDate10: null,
        Depth: null,
        ProfileDescription: null,
        Dimensions: null,
        Height: null,
        LastUpdatedDateTime: null,
        LastUpdateUserId: null,
        LocationType: null,
        MinimumUnits: null,
        MaximumUnits: null,
        ParentLocation: null,
        ParentLocationDescription: null,
        CapacityPieces: null,
        CapacityPiecesLimitFlag: null,
        ProfileCode: null,
        UserDefinedQuantity1: null,
        UserDefinedQuantity2: null,
        UserDefinedQuantity3: null,
        UserDefinedQuantity4: null,
        UserDefinedQuantity5: null,
        UserDefinedQuantity6: null,
        UserDefinedQuantity7: null,
        UserDefinedQuantity8: null,
        UserDefinedQuantity9: null,
        UserDefinedQuantity10: null,
        Record: null,
        UserDefinedReference1: null,
        UserDefinedReference2: null,
        UserDefinedReference3: null,
        UserDefinedReference4: null,
        UserDefinedReference5: null,
        UserDefinedReference6: null,
        UserDefinedReference7: null,
        UserDefinedReference8: null,
        UserDefinedReference9: null,
        UserDefinedReference10: null,
        Status: null,
        CapacityVolumeLimitFlag: null,
        Width: null,
        CapacityLimitFlag: null,
        CapacityContainerUnits: null,
        CapacityContainerLimitFlag: null,
        CapacityShippingUnits: null,
        CapacityShippingUnitsLimitFlag: null,
        CapacityGrossWeight: null,
        CapacityGrossWeightLimitFlag: null,
        CapacityNetWeight: null,
        CapacityNetWeightLimitFlag: null,
        Priority: null,
        Module: props.Module,
    };

    const [formFields, setformFields] = useState(initialFormFields);
    let createUrl = ""
    if (props.Module === WM)
        createUrl = "/wm/codes/location-data-entry-create";
    else if (props.Module === IM)
        createUrl = "/im/codes/location-data-entry-create";
    // Implement form load handler
    const handleFormLoad = useCallback(() => { }, []);

    const handleSearch = (e) => {
        e.event.stopPropagation();
        let datasource = loadDatasource(formFields);
        const filters = FillFilters(formFields);
        datasource.filter(filters);
        setResultData(datasource);
    }

    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        setResultData(loadDatasource(initialFormFields));
    }

    useEffect(() => {
    setResultData(loadDatasource(formFields));
    }, []);
    // Handle grid row selection to enable/disable Edit button
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length === 1) {
            rowId.current = selectedRowsData[0].RowId;
            setIsEditButtonDisabled(false);
        } else {
            rowId.current = null;
            setIsEditButtonDisabled(true);
        }
    };

    const loadDatasource = (filters) => {
        let store = createStore({
            key: 'RowId',
            loadParams: filters,
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.IM.GetLocations}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });

        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    const [resultData, setResultData] = useState(null);

    const handleValueChanged = (e) => { console.log(e) }

    const handleFieldValueChanged = (name, value, event) => { console.log(name, value, event) }

    const handleSelectedItemChanged = (name, event) => {
        console.log(name, event);
    };
    const handelEditClick = () => {
        let buttonUrl = "";
        if (props.Module === WM)
            buttonUrl = "/wm/codes/location-data-entry-edit?id=" + rowId.current;
        else if (props.Module === IM)
            buttonUrl = "/im/codes/location-data-entry-edit?id=" + rowId.current;
        history.push(buttonUrl);
    };
    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <AccordionReact
                            dataSource={searchpanel}
                            collapsible={true}
                            multiple={false}
                            animationDuration={300}
                            selectedItems={selectedItems}
                            //   onSelectionChanged={e => {
                            //     if (e.currentTarget === e.target) {
                            //          selectionChanged(e, e.target);
                            //     }
                            //   }}
                            itemTitleRender={() => (
                                <Toolbar className="accordian-toolbar">
                                    <Item location="before">
                                        <div className="title">
                                            <h6 style={{
                                                color: window._env_.Color2
                                            }}>Enter Your Query For Location Data Entry</h6>
                                        </div>
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                    </Item>
                                </Toolbar>
                            )}
                            itemRender={() => (
                                <FormField
                                    currrentUser={currentUser}
                                    layoutId='f81748d5-ba82-48e3-adc4-f6722fcd9ac6'
                                    layoutName='IMLocationDataEntrySearchForm'
                                    defaultFormSchema={SearchLayout}
                                    formFields={formFields}
                                    setformFields={setformFields}
                                    handleFieldValueChange={handleFieldValueChanged}
                                    handleSelectedItemChange={handleSelectedItemChanged}
                                    noSpacingBeforeFirstRow={true}
                                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                    formRefs={formRefs}
                                    onFormLoad={handleFormLoad}
                                />
                            )}
                            id="accordion-container" className="accordion-height"
                        />
                        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                            ref={dataGrid}
                            allowColumnReordering={true}
                            allowColumnResizing={true}
                            dataSource={resultData}
                            showBorders={true}
                            hoverStateEnabled={true}
                            className={searchPanelStatus ? "GridHeightAccordianOpen" : "GridHeightAccordianClose"}
                            onSelectionChanged={(e) => onSelectionChanged(e)}
                            remoteOperations={true}
                            searchEnabled={true}
                            columnAutoWidth={true}
                        >
                            <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                            >
                                <ColumnChooserSearch
                                    enabled={true}
                                    editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <ColumnHeaderFilter />
                            <Export enabled={true} allowExportSelectedData={true} />
                            <Selection mode="multiple" />
                            <Sorting visible={true} mode="multiple" />
                            <Paging defaultPageSize={10} />
                            <Pager
                                visible={true}
                                showPageSizeSelector={true}
                                allowedPageSizes={allowedPageSizes}
                                showNavigationButtons={true}
                            />
                            <FilterRow visible={true} />
                            <FilterPanel visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={loadState}
                                storageKey={gridKey}
                                customSave={saveState}
                            />
                            <FilterRow visible={true} />
                            <Column dataField="IdentityId" caption="Warehouse" ></Column>
                            <Column dataField="LocationCode" caption="Location" ></Column>
                            <Column dataField="Description" caption="Description" ></Column>
                            <Column dataField="MinPositionIndex" caption="Min Position Index" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="MaxPositionIndex" caption="Max Position Index" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="CapacityAreaLimitFlag" caption="Area" visible={false} ></Column>
                            <Column dataField="CapacityArea" caption="Capacity Area" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="CapacityUnits" caption="Capacity Units" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="CapacityVolume" caption="Capacity Volume" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="ClassCode" caption="Class" visible={false}></Column>
                            <Column dataField="SubClassCode" caption="Sub Class" visible={false}></Column>
                            <Column dataField="UserDefinedCode1" caption="Code 1" visible={false}></Column>
                            <Column dataField="UserDefinedCode2" caption="Code 2" visible={false}></Column>
                            <Column dataField="UserDefinedCode3" caption="Code 3" visible={false}></Column>
                            <Column dataField="UserDefinedCode4" caption="Code 4" visible={false}></Column>
                            <Column dataField="UserDefinedCode5" caption="Code 5" visible={false}></Column>
                            <Column dataField="UserDefinedCode6" caption="Code 6" visible={false}></Column>
                            <Column dataField="UserDefinedCode7" caption="Code 7" visible={false}></Column>
                            <Column dataField="UserDefinedCode8" caption="Code 8" visible={false}></Column>
                            <Column dataField="UserDefinedCode9" caption="Code 9" visible={false}></Column>
                            <Column dataField="UserDefinedCode10" caption="Code 10" visible={false}></Column>
                            <Column dataField="CreationUserId" caption="Creation By" visible={false}></Column>
                            <Column dataField="CreationDateTime" caption="Creation Date" visible={false} dataType="date" format="MM/dd/yyyy"></Column>
                            <Column dataField="UserDefinedDate1" caption="Date 1" visible={false} dataType="date" format="MM/dd/yyyy"></Column>
                            <Column dataField="UserDefinedDate2" caption="Date 2" visible={false} dataType="date" format="MM/dd/yyyy"></Column>
                            <Column dataField="UserDefinedDate3" caption="Date 3" visible={false} dataType="date" format="MM/dd/yyyy"></Column>
                            <Column dataField="UserDefinedDate4" caption="Date 4" visible={false} dataType="date" format="MM/dd/yyyy"></Column>
                            <Column dataField="UserDefinedDate5" caption="Date 5" visible={false} dataType="date" format="MM/dd/yyyy"></Column>
                            <Column dataField="UserDefinedDate6" caption="Date 6" visible={false} dataType="date" format="MM/dd/yyyy"></Column>
                            <Column dataField="UserDefinedDate7" caption="Date 7" visible={false} dataType="date" format="MM/dd/yyyy"></Column>
                            <Column dataField="UserDefinedDate8" caption="Date 8" visible={false} dataType="date" format="MM/dd/yyyy"></Column>
                            <Column dataField="UserDefinedDate9" caption="Date 9" visible={false} dataType="date" format="MM/dd/yyyy"></Column>
                            <Column dataField="UserDefinedDate10" caption="Date 10" visible={false} dataType="date" format="MM/dd/yyyy"></Column>
                            <Column dataField="Depth" caption="Depth" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="ProfileDescription" caption="Description" visible={false}></Column>
                            <Column dataField="Dimensions" caption="Dimensions" visible={false}></Column>
                            <Column dataField="Height" caption="Height" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="LastUpdatedDateTime" caption="Last Updated Date" visible={false} dataType="date" format="MM/dd/yyyy"></Column>
                            <Column dataField="LastUpdateUserId" caption="Last Update By" visible={false}></Column>
                            <Column dataField="LocationType" caption="Location Type" visible={false}></Column>
                            <Column dataField="MinimumUnits" caption="Minimum Units" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="MaximumUnits" caption="Maximum Units" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="ParentLocation" caption="Parent Location" visible={false}></Column>
                            <Column dataField="ParentLocationDescription" caption="Parent Location Description" visible={false}></Column>
                            <Column dataField="CapacityPieces" caption="Pieces" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="CapacityPiecesLimitFlag" caption="Pieces" visible={false}></Column>
                            <Column dataField="ProfileCode" caption="Profile" visible={false}></Column>
                            <Column dataField="UserDefinedQuantity1" caption="Quantity 1" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="UserDefinedQuantity2" caption="Quantity 2" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="UserDefinedQuantity3" caption="Quantity 3" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="UserDefinedQuantity4" caption="Quantity 4" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="UserDefinedQuantity5" caption="Quantity 5" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="UserDefinedQuantity6" caption="Quantity 6" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="UserDefinedQuantity7" caption="Quantity 7" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="UserDefinedQuantity8" caption="Quantity 8" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="UserDefinedQuantity9" caption="Quantity 9" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="UserDefinedQuantity10" caption="Quantity 10" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="Record" caption="Record#" visible={false}></Column>
                            <Column dataField="UserDefinedReference1" caption="Reference 1" visible={false}></Column>
                            <Column dataField="UserDefinedReference2" caption="Reference 2" visible={false}></Column>
                            <Column dataField="UserDefinedReference3" caption="Reference 3" visible={false}></Column>
                            <Column dataField="UserDefinedReference4" caption="Reference 4" visible={false}></Column>
                            <Column dataField="UserDefinedReference5" caption="Reference 5" visible={false}></Column>
                            <Column dataField="UserDefinedReference6" caption="Reference 6" visible={false}></Column>
                            <Column dataField="UserDefinedReference7" caption="Reference 7" visible={false}></Column>
                            <Column dataField="UserDefinedReference8" caption="Reference 8" visible={false}></Column>
                            <Column dataField="UserDefinedReference9" caption="Reference 9" visible={false}></Column>
                            <Column dataField="UserDefinedReference10" caption="Reference 10" visible={false}></Column>
                            <Column dataField="Status" caption="Status" visible={false}></Column>
                            <Column dataField="CapacityVolumeLimitFlag" caption="Volume" visible={false}></Column>
                            <Column dataField="Width" caption="Width" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="CapacityLimitFlag" caption="Capacity Limit" visible={false}></Column>
                            <Column dataField="CapacityContainerUnits" caption="Capacity Container Units" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="CapacityContainerLimitFlag" caption="Capacity Container Limit" visible={false}></Column>
                            <Column dataField="CapacityShippingUnits" caption="Capacity Shipping Units" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="CapacityShippingUnitsLimitFlag" caption="Capacity Shipping Units Limit" visible={false}></Column>
                            <Column dataField="CapacityGrossWeight" caption="Capacity Gross Weight" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="CapacityGrossWeightLimitFlag" caption="Capacity Gross Weight Limit" visible={false}></Column>
                            <Column dataField="CapacityNetWeight" caption="Capacity Net Weight" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}></Column>
                            <Column dataField="CapacityNetWeightLimitFlag" caption="Capacity Net Weight Limit" visible={false}></Column>
                            <Column dataField="Priority" caption="Priority" visible={false}></Column>
                            <GridToolbar>
                                <GridToolbarItem location="before">
                                    <Button
                                        disabled={isEditButtonDisabled}
                                        onClick={handelEditClick}
                                        type="default"
                                        text="Edit"
                                    ></Button>
                                </GridToolbarItem>
                                <GridToolbarItem location="before">
                                    <div>
                                        <Link to={createUrl}>
                                            <Button
                                                type="default"
                                                className="gridTopButton"
                                                text="Create"
                                            ></Button>
                                        </Link>
                                    </div>
                                </GridToolbarItem>
                                <GridToolbarItem location="after">
                                    <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                </GridToolbarItem>
                                <GridToolbarItem name="exportButton" />
                                <GridToolbarItem name="columnChooserButton" />
                            </GridToolbar>
                        </DataGrid>
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(LocationDataEntryList);